import { Controller } from "@hotwired/stimulus"

export default class TurboVisitController extends Controller {
  visit({ params: { url } }) {
    window.Turbo.visit(url)
  }
}
